import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp, FileImage } from "lucide-react";

const Product = () => {
  const location = useLocation();
  const product = location.state?.product;
  const [showBrochure, setShowBrochure] = useState(false);

  const [activeImage, setActiveImage] = useState(product.photos?.[0].data);

  const [applicationsIsOpen, setApplicationsIsOpen] = useState(true);

  if (!product) {
    return <h2 className="text-center text-red-500">Product not found</h2>;
  }

  return (
    <div className="container px-4 sm:px-6 md:px-0 md:mx-auto flex flex-col lg:flex-row gap-10 mt-8">
      {/* Image Section */}
      <div className="flex flex-col-reverse lg:flex-row lg:w-2/4 gap-3 h-5/6">
        {/* Column for all product images */}
        <div className="flex lg:flex-col justify-center items-center gap-4 h-full">
          {product.photos?.map((img, index) => (
            <div
              key={index}
              className="w-24 h-28 flex items-center justify-center bg-gray-100 rounded-xl cursor-pointer"
              onClick={() => setActiveImage(product.photos?.[index].data)}
            >
              <img
                src={product.photos?.[index].data}
                alt=""
                className="max-w-full max-h-full object-contain rounded-md"
              />
            </div>
          ))}
        </div>

        {/* Active Image */}
        <div className="w-full h-full">
          {/* Active Image Section */}
          <div className="w-full h-full min-h-[450px] flex items-center justify-center bg-gray-100 rounded-xl p-4 shadow-sm">
            <img
              src={activeImage}
              alt=""
              className="max-w-full max-h-[400px] rounded-xl"
            />
          </div>

          {/* View Broucher Button */}
          <div className="hidden lg:flex justify-center mt-4">
            <button 
              onClick={() => setShowBrochure(true)} 
              className="bg-blue-600 text-white px-4 py-2 w-96 rounded-lg flex justify-center gap-5">
              <FileImage />
              View Brochure
            </button>
          </div>
        </div>
      </div>

      {/* Product Details */}
      <div className="flex flex-col gap-2 lg:w-2/4">
        <div className="gap-2 ml-2">
          <h1 className="text-3xl font-bold">{product.name}</h1>
          <div className="mt-2">
            <span className="text-xs font-semibold text-white bg-blue-700 px-3 py-1 rounded-full uppercase tracking-wide">
              {product.productType}
            </span>
          </div>
        </div>
        <div className="mt-3 ml-2">
          <h2 className="text-lg font-semibold">Manufacturer</h2>
          <p>{product.manufacturer}</p>
        </div>
        <div className="mt-3 ml-2">
          <h2 className="text-lg font-semibold">Description</h2>
          <p className="text-justify text-gray-700">{product.description}</p>
        </div>
        <div className="mt-4">
          <button
            onClick={() => setApplicationsIsOpen(!applicationsIsOpen)}
            className="flex items-center justify-between w-full text-lg font-semibold bg-gray-200 px-2 py-2 rounded-md"
          >
            Applications
            {applicationsIsOpen ? (
              <ChevronUp size={20} />
            ) : (
              <ChevronDown size={20} />
            )}
          </button>

          <div
            className={`overflow-hidden transition-all duration-300 ${applicationsIsOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
              }`}
          >
            <ul className="list-disc list-outside pl-5 text-gray-700 mt-2">
              {product.applications.map((application, index) => (
                <li key={`application-${index}`} className="text-justify">
                  {application}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      {showBrochure && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center">
          <div className="relative bg-white p-6 rounded-lg w-3/4 max-w-4xl h-[80vh]">
            <button
              onClick={() => setShowBrochure(false)}
              className="absolute top-0 right-1 text-red-500 font-bold text-3xl"
            >
              ×
            </button>
            <iframe
              src={`https://drive.google.com/file/d/${product.brochure
                ?.split("/d/")[1]
                ?.split("/")[0]}/preview`}
              width="100%"
              height="100%"
              allow="autoplay"
              className="rounded-md"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default Product;
